import { Divider, Stack, Typography } from '@mui/material';
import { NOTIFICATION_ALERT_STATUSES,
  type ClientNotification } from '@weft/types';
import { isEmptyArray, isNotEmptyArray } from '@weft/utils';
import { useUpdateNotificationAlertStatus } from 'apps/app/src/hooks/requests/use-update-notification-alert-status';
import { runMutation } from 'apps/app/src/utils/vy-mutation';
import { HomePageSidebarNotificationItem } from './HomePageSidebarNotificationItem';
import { HomePageSidebarNotificationPlaceholders } from './HomePageSidebarNotificationPlaceholders';

type HomePageSidebarNotificationListProps = {
  clientNotifications?: ClientNotification[];
  isLoading?: boolean;
};

export const HomePageSideBarNotificationList: React.FC<
  HomePageSidebarNotificationListProps
> = ({ clientNotifications, isLoading }) => {
  const mutateNotificationAlertStatus = useUpdateNotificationAlertStatus();

  const handleDismiss = async ({ notificationAlert }: ClientNotification) => {
    await runMutation(
      mutateNotificationAlertStatus,
      {
        notificationAlertId: notificationAlert.id,
        updateNotificationAlertStatusRequest: {
          status: NOTIFICATION_ALERT_STATUSES.Dismissed,
        },
      },
      {
        pending: 'Dismissing...',
        success: 'Dismissed',
        error: 'Failed to dismiss',
      },
    );
  };

  return (
    <>
      <Stack
        gap={2}
        height="100%"
      >
        <Typography
          padding={2}
          variant="h6"
        >
          Notifications & Actions
        </Typography>
        <HomePageSidebarNotificationPlaceholders
          isEmpty={isEmptyArray(clientNotifications)}
          isLoading={isLoading ?? false}
        />
        <Stack
          height="100%"
          paddingX={2}
          overflow="auto"
          divider={
            
            <Divider
              orientation="horizontal"
              flexItem
            />
          }
          gap={1}
        >
          {isNotEmptyArray(clientNotifications) &&
            clientNotifications.map((clientNotification) => (
              <HomePageSidebarNotificationItem
                onDismiss={handleDismiss}
                clientNotification={clientNotification}
              />
            ))}
        </Stack>
      </Stack>
    </>
  );
};
